<template>
  <div class="min-h-screen flex flex-col">
    <div
      v-if="showUpgradePremiumScreen"
      class="min-h-screen bg-[#F9FAFB] flex flex-col"
    >
      <header
        class="sticky top-0 bg-white/80 backdrop-blur-md z-10 border-none"
      >
        <div class="max-w-md mx-auto px-4 py-3 flex items-center gap-3">
          <button
            class="p-2 -ml-2"
            aria-label="Back"
            @click="goBackFromUpgrade"
          >
            <i class="fas fa-arrow-left text-lg text-gray-900" />
          </button>
          <h1 class="text-base font-normal text-gray-900">
            Upgrade premium
          </h1>
        </div>
      </header>

      <main class="flex-1">
        <div class="max-w-md mx-auto px-4 pt-4 pb-28">
          <div class="bg-[#FF7A00] text-white rounded-2xl p-6 mb-6 text-center">
            <h2 class="text-lg font-semibold mb-2">
              It's time for Upgrade!
            </h2>
            <p class="text-white/90 text-sm">
              Upgrade to play and create all quizzes, please refer to the
              offered package
            </p>
          </div>

          <h3 class="text-lg font-semibold text-gray-900 mb-4">
            Premium Benefit
          </h3>

          <div class="space-y-4">
            <div
              class="bg-white rounded-2xl p-6 shadow-sm border border-gray-100"
            >
              <div class="flex flex-col items-center text-center">
                <div
                  class="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-4"
                >
                  <img
                    src="@/assets/game.png"
                    alt="Game"
                    class="w-8 h-8"
                  >
                </div>
                <h4 class="font-semibold text-gray-900 mb-2 text-base">
                  Unlimited Playing
                </h4>
                <p class="text-sm text-gray-500 leading-relaxed">
                  Enjoy unlimited games and keep the excitement going anytime!
                </p>
              </div>
            </div>

            <div
              class="bg-white rounded-2xl p-6 shadow-sm border border-gray-100"
            >
              <div class="flex flex-col items-center text-center">
                <div
                  class="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-4"
                >
                  <img
                    src="@/assets/mobile.png"
                    alt="Mobile"
                    class="w-8 h-8"
                  >
                </div>
                <h4 class="font-semibold text-gray-900 mb-2 text-base">
                  Free and No Ads
                </h4>
                <p class="text-sm text-gray-500 leading-relaxed">
                  Ad-free and hassle-free with a premium subscription.
                </p>
              </div>
            </div>

            <div
              class="bg-white rounded-2xl p-6 shadow-sm border border-gray-100"
            >
              <div class="flex flex-col items-center text-center">
                <div
                  class="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-4"
                >
                  <img
                    src="@/assets/colorfilter.png"
                    alt="Color Filter"
                    class="w-8 h-8"
                  >
                </div>
                <h4 class="font-semibold text-gray-900 mb-2 text-base">
                  Unlimited quiz
                </h4>
                <p class="text-sm text-gray-500 leading-relaxed">
                  Learn more with unlimited quizzes made just for you.
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>

      <footer class="fixed bottom-0 left-0 right-0">
        <div class="max-w-md mx-auto px-4 pb-6 pt-2">
          <button
            class="w-full bg-[#0B63F6] hover:bg-[#155EE0] text-white py-3.5 rounded-xl text-base font-semibold shadow-lg"
            @click="continueToPlans"
          >
            Continue
          </button>
        </div>
      </footer>
    </div>

    <div
      v-else
      class="min-h-screen bg-[#F9FAFB] flex flex-col"
    >
      <header
        class="sticky top-0 bg-white/80 backdrop-blur-md z-10 border-none"
      >
        <div class="max-w-md mx-auto px-4 py-3 flex items-center gap-3">
          <button
            class="p-2 -ml-2"
            aria-label="Back"
            @click="goBackFromMemberPlan"
          >
            <i class="fas fa-arrow-left text-lg text-gray-900" />
          </button>
          <h1 class="text-base font-normal text-gray-900">
            Choose Member Plan
          </h1>
        </div>
      </header>

      <main class="flex-1">
        <div class="max-w-md mx-auto px-4 pt-4 pb-28">
          <div class="bg-[#FF7A00] text-white rounded-2xl p-6 mb-6 text-center">
            <h2 class="text-lg font-semibold mb-2">
              It's time for Upgrade!
            </h2>
            <p class="text-white/90 text-sm">
              Upgrade to play and create all quizzes, please refer to the
              offered package
            </p>
          </div>

          <h2 class="text-lg font-normal text-gray-900 mb-3">
            Choose Member Plan
          </h2>

          <div class="space-y-3">
            <div
              v-for="plan in plans"
              :key="plan.id"
              class="relative cursor-pointer"
              @click="selectedPlanId = plan.id"
            >
              <div
                v-if="plan.badge"
                class="absolute -top-2 right-4 bg-[#F59E0B] text-white text-xs font-semibold px-3 py-1 rounded-lg z-10"
              >
                {{ plan.badge }}
              </div>

              <div
                :class="[
                  'rounded-2xl transition-all duration-200',
                  selectedPlanId === plan.id
                    ? 'bg-white border-2 border-[#0B63F6] p-1'
                    : 'bg-white border border-gray-200 hover:border-gray-300 p-4',
                ]"
              >
                <div
                  :class="
                    selectedPlanId === plan.id
                      ? 'bg-[#0B63F6] text-white rounded-xl p-4'
                      : ''
                  "
                >
                  <div class="mb-2">
                    <span
                      :class="
                        selectedPlanId === plan.id
                          ? 'text-white'
                          : 'text-[#0B63F6]'
                      "
                      class="text-2xl font-bold"
                    >
                      {{ plan.price }} {{ currency }}
                    </span>
                    <span
                      :class="
                        selectedPlanId === plan.id
                          ? 'text-white/80'
                          : 'text-gray-500'
                      "
                      class="text-sm font-medium"
                    >
                      /month
                    </span>
                  </div>

                  <h3
                    :class="
                      selectedPlanId === plan.id
                        ? 'text-white'
                        : 'text-gray-900'
                    "
                    class="text-base font-semibold mb-1"
                  >
                    {{ plan.title }}
                  </h3>

                  <p
                    :class="
                      selectedPlanId === plan.id
                        ? 'text-white/90'
                        : 'text-gray-500'
                    "
                    class="text-sm"
                  >
                    <span v-if="plan.id !== 'monthly'">
                      {{ plan.subtitle }}
                    </span>
                    <span v-else>
                      {{ plan.shortSubtitle }}
                      <button
                        class="font-medium"
                        :class="
                          selectedPlanId === plan.id
                            ? 'text-white underline'
                            : 'text-[#0B63F6]'
                        "
                        @click.stop="openBenefitsModal(plan)"
                      >
                        see more...
                      </button>
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>

      <footer class="fixed bottom-0 left-0 right-0 pointer-events-none">
        <div class="max-w-md mx-auto px-4 pb-6 pt-2 pointer-events-auto">
          <button
            class="w-full bg-[#0B63F6] hover:bg-[#155EE0] text-white py-3.5 rounded-xl text-base font-semibold shadow-xl"
            :disabled="processing || !canUpgrade"
            @click="showPaymentModal"
          >
            Continue
          </button>
        </div>
      </footer>

      <transition name="fade">
        <div
          v-if="cancelModalOpen"
          class="fixed inset-0 z-50 bg-black/40 flex items-end justify-center lg:items-center"
          @keydown.esc="closeCancelModal"
          @click="closeCancelModal"
        >
          <div
            class="w-full max-w-md bg-white rounded-t-3xl lg:rounded-2xl p-6 pb-5 shadow-xl"
            @click.stop
          >
            <div
              class="w-12 h-1.5 bg-gray-300 rounded-full mx-auto mb-3 lg:hidden"
            />

            <div class="flex justify-center mb-3">
              <img
                src="@/assets/unsubscribe.png"
                alt="unsubscribe"
                class="w-40 h-40 object-contain"
              >
            </div>

            <h3 class="text-base font-semibold text-center text-gray-900">
              Sure want unsubscription?
            </h3>
            <p class="text-sm text-gray-500 text-center mt-1">
              Kamu akan kehilangan semua benefit
            </p>

            <div class="mt-5 space-y-3">
              <button
                class="w-full bg-[#0B63F6] hover:bg-[#155EE0] text-white py-3 rounded-xl text-base font-semibold"
                :disabled="processing"
                @click="closeCancelModal"
              >
                Stay subscribe
              </button>
              <button
                class="w-full bg-[#F87171] hover:bg-[#ef4444] text-white py-3 rounded-xl text-base font-semibold disabled:opacity-60"
                :disabled="processing"
                @click="confirmUnsubscribe"
              >
                {{ processing ? "Unsubscribing..." : "Unsubscribe" }}
              </button>
            </div>
          </div>
        </div>
      </transition>

      <transition name="fade">
        <div
          v-if="successModalOpen"
          class="fixed inset-0 z-50 bg-black/40 flex items-end justify-center"
          @keydown.esc="closeSuccessModal"
          @click="closeSuccessModal"
        >
          <div
            class="w-full max-w-md bg-white rounded-2xl p-6 shadow-xl text-center"
            @click.stop
          >
            <img
              src="@/assets/unsubscribe.png"
              alt="success"
              class="w-36 h-36 object-contain mx-auto mb-2"
            >
            <h3 class="text-base font-semibold text-gray-900 mb-1">
              Unsubscription success
            </h3>
            <p class="text-sm text-gray-500 mb-6">
              Kamu sudah kehilangan semua benefit
            </p>
            <button
              class="w-full bg-[#0B63F6] hover:bg-[#155EE0] text-white py-3 rounded-xl text-base font-semibold"
              @click="closeSuccessModal"
            >
              OK
            </button>
          </div>
        </div>
      </transition>
    </div>

    <Transition name="modal">
      <div
        v-if="showUpgradeModal"
        class="fixed inset-0 z-50 flex items-end justify-center bg-black/50 px-4"
        @click="closeUpgradeModal"
      >
        <div
          class="w-full max-w-md bg-white rounded-t-3xl rounded-b-3xl p-6 mb-4 transform transition-transform duration-300"
          @click.stop
        >
          <div class="flex justify-end items-center mb-2">
            <button
              class="p-2 hover:bg-gray-100 rounded-full"
              @click="closeUpgradeModal"
            >
              <i class="fas fa-times text-gray-500" />
            </button>
          </div>

          <div class="text-center mb-4">
            <img
              src="@/assets/crown-uprage-pro.png"
              alt="crown"
              class="w-32 h-32 flex items-center justify-center mx-auto"
            >
            <h4 class="text-lg font-semibold text-gray-900 mb-1">
              It's time for Upgrade!
            </h4>
            <p class="text-gray-600 text-sm">
              Upgrade to play and create all quizzes, please refer to the
              offered package
            </p>
          </div>

          <div>
            <button
              class="w-full bg-blue-600 text-white py-3 rounded-full text-base font-semibold hover:bg-blue-700"
              @click="upgradeNow"
            >
              Upgrade pro first
            </button>
          </div>
        </div>
      </div>
    </Transition>

    <Transition name="modal">
      <div
        v-if="showBenefitsModal"
        class="fixed inset-0 z-50 flex items-end justify-center bg-black/50 px-4"
        @click="closeBenefitsModal"
      >
        <div
          class="w-full max-w-md bg-white rounded-2xl p-6 mb-4 transform transition-transform duration-300"
          @click.stop
        >
          <div class="flex flex-col items-center justify-center pt-8 pb-4">
            <div
              class="w-20 h-20 bg-orange-100 rounded-xl flex items-center justify-center relative shadow-inner"
              style="background-color: #fef3c7"
            >
              <span
                class="absolute top-0.5 left-0.5 w-1.5 h-1.5 bg-orange-300 rounded-full"
              />
              <span
                class="absolute top-2 right-1 w-1 h-1 bg-orange-300 rounded-full"
              />
              <span
                class="absolute bottom-2 left-1 w-1.5 h-1.5 bg-orange-300 rounded-full"
              />
              <span
                class="absolute bottom-1 right-2 w-1 h-1 bg-orange-300 rounded-full"
              />
              <i
                class="fas fa-crown text-orange-500 text-4xl"
                style="color: #f59e0b"
                aria-hidden="true"
              />
            </div>
          </div>

          <h4 class="text-xl font-semibold text-gray-900 mb-4 text-center">
            {{ selectedPlan.title }}
          </h4>

          <div class="space-y-4">
            <h5 class="text-base font-semibold text-gray-900">
              Benefits:
            </h5>
            <ul class="list-none space-y-2 text-sm text-gray-700">
              <li
                v-for="(benefit, index) in selectedPlan.benefits"
                :key="index"
                class="flex items-start"
              >
                <span class="text-[#0B63F6] text-xl leading-none mr-2">•</span>
                <span>{{ benefit }}</span>
              </li>
            </ul>

            <div class="pt-2">
              <h5 class="text-base font-semibold text-gray-900 mb-2">
                Billing Info:
              </h5>
              <p class="text-sm text-gray-700">
                {{ selectedPlan.billingInfo }}
              </p>
            </div>
          </div>

          <div class="mt-6">
            <button
              class="w-full bg-[#0B63F6] text-white py-3.5 rounded-xl text-base font-semibold hover:bg-[#155EE0]"
              @click="closeBenefitsModal"
            >
              OK
            </button>
          </div>
        </div>
      </div>
    </Transition>

    <!-- Payment Method Modal (Bottom Sheet Style) -->
    <transition name="slide-up">
      <div
        v-if="showPaymentMethodModal"
        class="fixed bottom-0 left-0 right-0 z-50"
      >
        <div
          class="w-full bg-white rounded-t-3xl shadow-2xl border-t border-gray-100"
        >
          <PaymentMethodModal
            @close="closePaymentModal"
            @paymentSuccess="handlePaymentSuccess"
          />
        </div>
      </div>
    </transition>

    <!-- Success Modal -->
    <SuccessModal
      v-if="showSuccessModal"
      @close="closeSuccessModal"
    />
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import { useRoute } from "vue-router";
import PaymentMethodModal from "@/components/subscribe/PaymentMethodModal.vue";
import SuccessModal from "@/components/subscribe/SuccessModal.vue";

const props = defineProps({
  currentPlanId: { type: String, default: "monthly" },
  currency: { type: String, default: "MYR" },
});

const route = useRoute();
const currency = computed(() => props.currency);

const emit = defineEmits(["goBack"]);

function goBackFromUpgrade() {
  emit("goBack");
}

function goBackFromMemberPlan() {
  emit("goBack");
}

// Quiz intro state
const showQuizIntro = ref(true);

const plans = ref([
  {
    id: "free",
    price: 0,
    title: "Free",
    subtitle: "Access to basic features",
  },
  {
    id: "monthly",
    price: 19,
    title: "Monthly Plan", // Changed title slightly for consistency with modal
    shortSubtitle: "Access all lessons, quizzes, and", // New short subtitle
    subtitle: "Recurring monthly billing", // Original subtitle (kept for now, but not used in the UI anymore)
    badge: "SAVE 30%",
    // NEW: Detailed Benefits for the modal
    benefits: [
      "Access to all premium courses and lessons",
      "Unlimited quizzes and educational games",
      "Join and replay live classes anytime",
      "Ad-free and seamless learning experience",
      "Exclusive early access to new lessons & events",
    ],
    billingInfo:
      "Recurring subscription cancel anytime from your account settings.",
  },
  {
    id: "semiannual",
    price: 299,
    title: "6 months plan",
    subtitle: "Unlock all features and save 20%",
  },
  {
    id: "yearly",
    price: 399,
    title: "Yearly plan",
    subtitle: "Get over 40% off",
  },
]);

const selectedPlanId = ref(props.currentPlanId);
const processing = ref(false);

// Modals
const cancelModalOpen = ref(false);
const successModalOpen = ref(false);
const showUpgradeModal = ref(false);
const showUpgradePremiumScreen = ref(false);
const showPaymentMethodModal = ref(false);
const showSuccessModal = ref(false);
const showBenefitsModal = ref(false);
const selectedPlan = ref({});

// Check query parameter on mount
onMounted(() => {
  showUpgradePremiumScreen.value = true;
  if (route.query.showUpgradePremiumScreen === "true") {
    showQuizIntro.value = false;
    showUpgradePremiumScreen.value = true;
  }
});

// Helpers
// const isActive = (id) => id === props.currentPlanId;
const canUpgrade = computed(() => selectedPlanId.value !== props.currentPlanId);

// Navigation
// function goBack() {
//   router.back();
// }

// Upgrade handlers
// function selectAndUpgrade(id) {
//   selectedPlanId.value = id;
//   upgrade();
// }

// async function upgrade() {
//   if (!canUpgrade.value) return;
//   try {
//     processing.value = true;
//     // await UpgradePlanAPI({ planId: selectedPlanId.value });
//   } catch (e) {
//     console.error(e);
//   } finally {
//     processing.value = false;
//   }
// }

// Cancel modal handlers
// function openCancelModal() {
//   cancelModalOpen.value = true;
// }

function closeCancelModal() {
  if (processing.value) return;
  cancelModalOpen.value = false;
}

function openBenefitsModal(plan) {
  selectedPlan.value = plan;
  showBenefitsModal.value = true;
}

function closeBenefitsModal() {
  showBenefitsModal.value = false;
  selectedPlan.value = {}; // Clear plan details on close
}

async function confirmUnsubscribe() {
  try {
    processing.value = true;
    // await CancelSubscriptionAPI()
    cancelModalOpen.value = false;
    // successModalOpen.value = true; // ✅ tampilkan modal sukses
  } catch (e) {
    console.error(e);
  } finally {
    processing.value = false;
  }
}

// function closeSuccessModal() {
//   successModalOpen.value = false;
//   // optional: redirect/refresh data
//   // router.replace('/'); atau emit event ke parent
// }

// Upgrade modal handlers
function closeUpgradeModal() {
  showUpgradeModal.value = false;
}

function upgradeNow() {
  // Show upgrade premium screen
  showUpgradeModal.value = false;
  showQuizIntro.value = false;
  showUpgradePremiumScreen.value = true;
}

function continueToPlans() {
  showUpgradePremiumScreen.value = false;
  // Show the original subscribe content (member plans)
}

// Payment modal handlers
function showPaymentModal() {
  console.log("showPaymentModal called"); // Debug log
  showPaymentMethodModal.value = true;
  console.log("showPaymentMethodModal:", showPaymentMethodModal.value); // Debug log
}

function closePaymentModal() {
  showPaymentMethodModal.value = false;
}

// Handle payment success
function handlePaymentSuccess(paymentMethod) {
  console.log("Payment successful with method:", paymentMethod);
  // Close payment modal
  showPaymentMethodModal.value = false;
  // Show success modal
  showSuccessModal.value = true;
}

// Close success modal
function closeSuccessModal() {
  showSuccessModal.value = false;
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/* Modal animation */
.modal-enter-active {
  transition: all 0.3s ease-out;
}
.modal-leave-active {
  transition: all 0.3s ease-in;
}
.modal-enter-from {
  opacity: 0;
}
.modal-enter-from .w-full.max-w-md {
  transform: translateY(100%);
}
.modal-leave-to {
  opacity: 0;
}
.modal-leave-to .w-full.max-w-md {
  transform: translateY(100%);
}

/* Bottom Sheet Slide Up Animation */
.slide-up-enter-active {
  transition: transform 0.3s ease-out;
}
.slide-up-leave-active {
  transition: transform 0.3s ease-in;
}
.slide-up-enter-from {
  transform: translateY(100%);
}
.slide-up-leave-to {
  transform: translateY(100%);
}
</style>
